var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgLogoHelixKineAcu = function SvgLogoHelixKineAcu(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    viewBox: "0 0 82.13 41.47",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.3,32.55C-3.97,23.05-.7,5.74,12.16,1.36,16.09.07,20.27-.3,24.34.24c0,0,0,.11,0,.11-4.02-.14-8.1.4-11.87,1.81C0,7.1-2.3,22.57,5.3,32.55h0Z",
    style: {
      fill: "#7fba27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2,9.51c.1-1.51-2.03-1.67-2.17-.22-.2,1.46,2.03,1.75,2.17.22h0ZM16.28,9.52c-.17,2.05-3.28,1.71-3.11-.31.27-2.06,3.28-1.75,3.11.31h0Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.46,9.18c1.95,2.26,3.91,4.36,5.39,7,.5,1,.65,2.35.23,3.43-.29.61-.59,1.23-.91,1.83-1.58,2.81-3.33,5.03-1.29,8.14.59,1.11,1.32,2.17,1.98,3.28l-.08.06c-2.87-3.44-5.13-5.84-2.39-10.26,0,0,1.8-3.39,1.8-3.39.34-.83.25-1.89-.15-2.74-.82-1.77-3.61-5.59-4.68-7.3,0,0,.08-.06.08-.06h0Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.58,6.89c-4.15,2.67-8.06,7.08-7.46,12.29.32,2.42,2.16,4.8,2.59,7.4.72,4.85-3.09,8.87-6.53,11.67,0,0-4.22,3.21-4.22,3.21l-.07-.07c4.65-4.33,12.63-9.88,9.05-17.11-1.62-3.12-2.56-6.88-.85-10.19,1.46-3.11,4.46-6,7.49-7.2h0Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.88,21.65v-12.6s1.23,0,1.23,0v5.83s7.56,0,7.56,0v-5.83s1.23,0,1.23,0v12.6s-1.23,0-1.23,0v-6.34s-7.56,0-7.56,0v6.34s-1.23,0-1.23,0Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.57,21.66v-12.6s5.49,0,5.49,0v.88l-3.15-.42c-.55-.07-.92-.11-1.12-.11v5.49c.15,0,.53-.02,1.11-.05l2.95-.18v.83l-2.95-.18c-.59-.04-.96-.05-1.12-.05v6.03c.21,0,.59-.04,1.13-.11l3.19-.41v.88s-5.54,0-5.54,0Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.89,9.06h1.22s0,12.24,0,12.24c.23,0,.59-.04,1.08-.11l2.99-.45v.92s-5.29,0-5.29,0v-12.6Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.19,21.66v-12.6h1.23v12.6h-1.23Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.33,21.66l4.65-6.28-4.28-6.32h1.44s3.54,5.24,3.54,5.24h.11l3.08-5.24h1.44s-4.32,5.71-4.32,5.71l4.68,6.9h-1.44s-3.94-5.82-3.94-5.82h-.11l-3.4,5.81h-1.44Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.71,30.34v-1.21h.12v1.21h-.12ZM43.46,30.34l-.57-.62.52-.59h.15l-.57.54.62.67h-.16Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.87,30.34v-1.21h.12v1.21h-.12Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.41,30.34l.04-1.23h.02l.87,1.05h.01l-.04-1.02h.12l-.04,1.23h-.02l-.87-1.05h-.01l.04,1.02h-.12Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.86,30.34v-1.21h.53v.08l-.3-.04c-.05,0-.09,0-.11,0v.53s.05,0,.11,0l.28-.02v.08l-.28-.02c-.06,0-.09,0-.11,0v.58s.06,0,.11-.01l.31-.04v.08h-.53Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.64,30.31v-.1h.02s.1.07.15.09c.06.02.11.03.17.03.08,0,.14-.02.19-.06.05-.04.07-.1.07-.17,0-.04,0-.08-.03-.11-.02-.04-.05-.07-.09-.11-.04-.04-.1-.07-.17-.12-.05-.03-.1-.06-.14-.09s-.08-.07-.11-.11c-.03-.04-.04-.09-.04-.15,0-.09.03-.16.09-.21s.15-.08.25-.08c.05,0,.1,0,.15.01s.09.02.12.04v.1h-.02c-.07-.07-.15-.11-.25-.11-.07,0-.13.02-.18.06-.04.04-.07.09-.07.15,0,.05.01.09.04.12.02.03.06.06.1.09.04.03.08.05.13.08.05.03.1.06.15.09s.09.07.12.12c.03.05.05.1.05.17,0,.06-.02.12-.04.17-.03.05-.07.09-.13.11-.05.03-.12.04-.19.04-.05,0-.1,0-.16-.02-.06-.01-.12-.03-.18-.04Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.69,30.35v-1.21h.12v1.21h-.12Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.53,30.35v-1.17s-.05,0-.11,0l-.34.04v-.09h1.01v.09l-.34-.04c-.05,0-.09,0-.11,0v1.17h-.12Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.37,30.35v-1.21h.12v.56h.72s0-.56,0-.56h.12v1.21h-.12v-.61h-.72s0,.61,0,.61h-.12Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.78,30.35v-1.21h.53v.08l-.3-.04c-.05,0-.09,0-.11,0v.53s.05,0,.11,0l.28-.02v.08l-.28-.02c-.06,0-.09,0-.11,0v.58s.06,0,.11-.01l.31-.04v.08h-.53Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.67,29.14h.23c.12,0,.22.03.28.08.07.05.1.12.1.21,0,.07-.02.13-.06.18s-.1.08-.18.09h0c.08.03.14.06.19.12.05.06.08.13.11.21.02.08.04.13.07.18.02.04.04.07.07.09.03.02.06.03.09.04h0s-.07.01-.07.01c-.05,0-.09,0-.12-.03-.03-.02-.06-.05-.08-.09-.02-.04-.04-.1-.07-.18-.03-.12-.08-.2-.13-.25-.05-.05-.12-.07-.2-.07h-.01v-.03h.01c.18,0,.28-.08.28-.25s-.09-.25-.26-.25h-.11v1.17h-.12v-1.21Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.65,30.35l.46-1.21h.11l.46,1.21h-.13l-.21-.57h-.39l-.18.57h-.13ZM53.13,29.23l-.16.51h.36l-.19-.51h-.01Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.97,30.35v-1.21h.21c.14,0,.25.03.33.09.08.06.12.14.12.25s-.04.19-.12.25c-.08.06-.19.09-.33.09h-.1v.54h-.12ZM54.18,29.18h-.1v.59h.1c.21,0,.32-.1.32-.29s-.11-.29-.32-.29Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.95,30.35v-1.21h.12v1.21h-.12Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.52,30.35v-1.21h.53v.08l-.3-.04c-.05,0-.09,0-.11,0v.53s.05,0,.11,0l.28-.02v.08l-.28-.02c-.06,0-.09,0-.11,0v.58s.06,0,.11-.01l.31-.04v.08h-.53Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.65,30.35l-.16-.18c-.05.07-.1.12-.15.15-.05.03-.12.05-.19.05s-.14-.01-.2-.04c-.06-.03-.1-.07-.13-.11-.03-.05-.05-.11-.05-.17,0-.08.02-.15.07-.21s.12-.11.21-.14v-.02c-.07-.06-.1-.11-.13-.16-.02-.05-.03-.1-.03-.14,0-.08.02-.14.07-.19s.11-.07.2-.07.14.02.19.06.07.1.07.17c0,.06-.02.12-.06.18-.04.06-.1.1-.17.14l.34.37.12-.32h.12l-.21.35.26.28h-.15ZM56.88,30.03c0,.09.03.16.08.21.05.05.12.08.2.08.12,0,.21-.06.3-.19l-.39-.42c-.13.07-.19.17-.19.32ZM57.11,29.59l.05.05c.1-.07.15-.16.15-.28,0-.07-.01-.12-.04-.15-.03-.04-.06-.05-.11-.05s-.09.02-.12.05c-.03.04-.05.08-.05.14,0,.04,0,.08.03.12.02.04.05.08.09.13Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.36,30.35l.46-1.21h.11l.46,1.21h-.13l-.21-.57h-.39l-.18.57h-.13ZM58.84,29.23l-.16.51h.36l-.19-.51h-.01Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.62,30.2v.11s-.08.03-.13.04c-.05.01-.09.02-.14.02-.05,0-.09,0-.12,0-.09,0-.18-.02-.26-.05-.08-.03-.15-.08-.21-.13-.06-.06-.11-.12-.14-.2-.03-.08-.05-.16-.05-.25s.02-.17.05-.25c.03-.08.08-.14.14-.2.06-.06.13-.1.21-.13.08-.03.17-.05.26-.05.04,0,.08,0,.13,0,.05,0,.09.01.14.02.04,0,.08.02.11.03v.1h-.02s-.1-.07-.16-.09c-.06-.02-.13-.03-.2-.03-.1,0-.2.02-.27.07-.08.05-.14.12-.18.21-.04.09-.07.19-.07.31s.02.22.07.31c.04.09.11.16.18.2s.17.07.27.07c.08,0,.15-.01.22-.04s.12-.06.17-.09h0Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.95,29.14h.12v.73c0,.14.03.25.1.33.07.08.17.12.29.12.08,0,.15-.01.2-.05.06-.03.1-.07.13-.13.03-.05.05-.12.04-.19l-.03-.81h.12l-.03.81c0,.14-.05.24-.12.31-.08.07-.19.11-.33.11-.16,0-.28-.04-.36-.14-.09-.09-.13-.21-.13-.37v-.72Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.34,30.35v-1.21h.21c.14,0,.25.03.33.09.08.06.12.14.12.25s-.04.19-.12.25c-.08.06-.19.09-.33.09h-.1v.54h-.12ZM62.56,29.18h-.1v.59h.1c.21,0,.32-.1.32-.29s-.11-.29-.32-.29Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.31,29.14h.12v.73c0,.14.03.25.1.33.07.08.17.12.29.12.08,0,.15-.01.2-.04.06-.03.1-.07.13-.13.03-.05.05-.12.04-.19l-.03-.81h.12l-.03.81c0,.14-.05.24-.12.31-.08.07-.19.11-.33.11-.16,0-.28-.04-.36-.14-.09-.09-.13-.21-.13-.37v-.72Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.68,30.35l.04-1.23h.02l.87,1.05h.01l-.04-1.02h.12l-.04,1.23h-.02l-.87-1.05h-.01l.04,1.02h-.12Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.08,30.2v.11s-.08.03-.13.04c-.05.01-.09.02-.14.02-.05,0-.09,0-.12,0-.09,0-.18-.02-.26-.05-.08-.03-.15-.08-.21-.13-.06-.06-.11-.12-.14-.2-.03-.08-.05-.16-.05-.25s.02-.17.05-.25c.03-.08.08-.14.14-.2.06-.06.13-.1.21-.13.08-.03.17-.05.26-.05.04,0,.08,0,.13,0,.05,0,.09.01.14.02.04,0,.08.02.11.03v.1h-.02s-.1-.07-.16-.09-.13-.03-.2-.03c-.1,0-.2.02-.27.07-.08.05-.14.12-.18.21-.04.09-.07.19-.07.31s.02.22.07.31c.04.09.11.16.18.2s.17.07.27.07c.08,0,.15-.01.22-.04.07-.02.12-.06.17-.09h0Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7,30.35v-1.17s-.05,0-.11,0l-.34.04v-.09h1.01v.09l-.34-.04c-.05,0-.09,0-.11,0v1.17h-.12Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.53,29.14h.12v.73c0,.14.03.25.1.33.07.08.17.12.29.12.08,0,.15-.01.2-.05.06-.03.1-.07.13-.13.03-.05.05-.12.04-.19l-.03-.81h.12l-.03.81c0,.14-.05.24-.12.31-.08.07-.19.11-.33.11-.16,0-.28-.04-.36-.14-.09-.09-.13-.21-.13-.37v-.72Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.91,29.14h.12v.73c0,.14.03.25.1.33.07.08.17.12.29.12.08,0,.15-.01.2-.05.06-.03.1-.07.13-.13.03-.05.05-.12.04-.19l-.03-.81h.12s-.03.81-.03.81c0,.14-.05.24-.12.31-.08.07-.19.11-.33.11-.16,0-.28-.04-.36-.14-.09-.09-.13-.21-.13-.37v-.72Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3,29.15h.23c.12,0,.22.03.28.08.07.05.1.12.1.21,0,.07-.02.13-.06.18s-.1.08-.18.09h0c.08.03.14.06.19.12.05.06.08.13.11.21.02.08.04.13.07.18.02.04.04.07.07.09.03.02.06.03.09.04h0s-.07.01-.07.01c-.05,0-.09,0-.12-.03-.03-.02-.06-.05-.08-.09-.02-.04-.04-.1-.07-.18-.03-.12-.08-.2-.13-.25-.05-.05-.12-.07-.2-.07h-.01v-.03h.01c.18,0,.28-.08.28-.25s-.09-.25-.26-.25h-.11v1.17h-.12v-1.21Z",
    style: {
      fill: "#275124"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.84,25.15c15.67-.15,31.33-.16,47,0-15.67.16-31.33.15-47,0h0Z",
    style: {
      fill: "#7fba27"
    }
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoHelixKineAcu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo_helix_kine-acu.caf81905.svg";
export { ForwardRef as ReactComponent };